export default "__VITE_ASSET__d759835a__"